import { fromJS } from 'immutable';

import {ApiUrl2, ApiReport, PrevilageId, UserToken} from '../../../helper/HelperAuth'
import {GetReportInteractive, GlobalLoading} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, body) => async (dispatch, getState) => {

    dispatch({ type: GlobalLoading, showLoading: true});
    const Authorization = UserToken;
    //
    const urlAccess = ApiUrl2 + 'config-accessmodule-list';
    var paramBodyAccess = {
        "query":{
            "privilege-id":PrevilageId,
        }
    };

    const argumentAccess = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBodyAccess)
    };

    const responseAccess = await doFetch(urlAccess,argumentAccess);
    let dataAccess = fromJS({});
    let array = [];
    let action = 0;
    let show = '';
    if(responseAccess.ok){
        dataAccess = fromJS(await responseAccess.json());
        dataAccess = dataAccess.get('query-result');
    }

    let menuPrev = fromJS(dataAccess).get('data')
    {menuPrev.map((data, i) =>
        array.push({
            'menu-name' :data.get('menu-name'),
            'action-id' : data.get('action-id')
        })

    )}
    for (let i = 0; i < array.length; i++) {
        if (array[i]['menu-name'] === 'Report Chatbot') {
            action = array[i]['action-id']
        }
    }

    var query = {
        'search':body,
        'page':page,
        'page-size':10,
        'order-by':4,
        'order':'DESC',
    };

    if (action == 3 || action == 4) {
        query = {
            "search":body,
            "page":page,
            "page-size":10,
            "order-by":4,
            "order":"DESC",
            "show" : 'all'
        };
    }


    //
    const url = ApiReport + 'report-interactive-list';
    if(page === undefined){
        page = 1;
    }

    if(search != null){
        search.map((v,k)=>{ 
            if(v !== ''){
                query[k] = v;
            }
        });
    }

    var paramBody = {
        'query': query
    };

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        var items = []
        data.get('data').map((item) => {
            var reqData = item.get('request-data');
            items.push({
                'client-id':reqData.get('client-id'),
                'division-id':reqData.get('division-id'),
                'sender-id':reqData.get('sender-id'),
                'template-id':reqData.get('template-id'),
                'start-date':reqData.get('start-date'),
                'end-date':reqData.get('end-date'),
                'request-data':item.get('request-data'),
                'requestid':item.get('requestid'),
                'client-name':item.get('client-name'),
                'division-name':item.get('division-name'),
                'file-name':item.get('file-name'),
                'file-path':item.get('file-path'),
                'request-date':item.get('request-date'),
                'status':item.get('status'),
                'summary-file':item.get('summary-file'),
                'summary-path':item.get('summary-path'),
                'summary-status':item.get('summary-status'),
                'report-format':item.get('report-format'),
                'report-format-name':item.get('report-format-name'),
                'reportLinkSummary':item.get('report-link-summary'),
                'reportLinkDetail':item.get('report-link-detail'),
                'part':item.get('part'),
            })
            
        })

        var data2 = {
            'row-count': data.get('row-count'),
            'page-size': data.get('page-size'),
            'page-count': data.get('page-count'),
            'order-by': data.get('order-by'),
            'page': data.get('page'),
            'order': data.get('order'),
            'data': items
        }
    }

    dispatch({ type: GlobalLoading, showLoading: false});
    dispatch({ type: GetReportInteractive, data: fromJS(data2) });
};